import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
import { getStepTitle } from '../utils/getStepTitle';
import { Step } from 'signup-constants/Step';
import { OptionalFormattedMessage } from './OptionalFormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TITLE_CENTERED_STEPS = [Step.ExistingUser, Step.Verification, Step.CodeVerification];
const StyledStepTitleText = styled.span.withConfig({
  displayName: "StepTitle__StyledStepTitleText",
  componentId: "we7w67-0"
})(["display:block;font-size:2rem;font-weight:700;", " ", " @media ", "{", " ", " ", " ", "}"], props => TITLE_CENTERED_STEPS.includes(props.$stepKey) && `text-align: center;`, props => props.theme.embedded && `margin-top: 20px;
  text-align: center;
  font-size: 1.75rem;`, devices.desktop, props => props.$updateStyling && 'line-height: 45px;', props => props.$updateStyling && props.$stepKey !== Step.Password && `padding-left: 50px;
    padding-right: 50px;`, props => props.$stepKey === Step.JobRole && `padding-left: 75px;
      padding-right: 75px;`, props => (props.$stepKey === Step.OptionalPhoneNumber || props.$stepKey === Step.PhoneNumber) && `padding-left: 35px;
        padding-right: 35px;`);
export const StepTitle = ({
  stepKey,
  message = null,
  className = '',
  children,
  shouldShowDefault = true,
  updateStyling = false
}) => {
  const title = useSelector(getStepTitle);
  const classNames = `${stepKey} ${className}`;
  return /*#__PURE__*/_jsx(H2, {
    "aria-level": 2,
    children: /*#__PURE__*/_jsxs(StyledStepTitleText
    // @ts-expect-error Expression produces a union type that is too complex to represent.
    , {
      $stepKey: stepKey,
      $updateStyling: updateStyling,
      className: classNames,
      children: [shouldShowDefault && /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: message || title
      }), children]
    })
  });
};